const authChannel = new BroadcastChannel('auth')
export default authChannel
